/**
 * Index mondial des étapes des Fêtes populaires de saint Léonard 2027.
 * Timeline chronologique + carte des lieux.
 */
import { Link } from "react-router-dom";
import Ornament from "@/components/Ornament";
import SeoHead from "@/components/SeoHead";
import { FETES_LOCATIONS_SORTED } from "@/data/fetesInternationales";

const SEO_TITLES = {
  fr: "Fêtes populaires de saint Léonard 2027 — étapes mondiales · Millenium",
  en: "Popular Popular Feasts of Saint Léonard 2027 — worldwide stops · Millennium",
};
const SEO_DESC = {
  fr: "Sept étapes mondiales des Fêtes populaires de saint Léonard en 2027 : Mansourah (Égypte), Bethléem & Jérusalem, Saint-Pétersbourg, Norwich, Londres, Rabat, Cotonou. Millenium 2027 du Prieuré saint Léonard, baie du Mont-Saint-Michel.",
  en: "Seven worldwide stops of the Popular Popular Feasts of Saint Léonard in 2027: Mansourah (Egypt), Bethlehem & Jerusalem, Saint Petersburg, Norwich, London, Rabat, Cotonou. Millennium 2027 of the Priory of Saint Léonard, bay of Mont-Saint-Michel.",
};

export default function FetesInternationalesIndex() {
  return (
    <>
      <SeoHead titles={SEO_TITLES} descriptions={SEO_DESC} />
      <div data-testid="fetes-intl-index" style={{ background: "var(--parchment)" }}>
        {/* HERO */}
        <section className="py-16 sm:py-20 px-6 text-center border-b" style={{ borderColor: "var(--gold)" }}>
          <Ornament />
          <p className="font-caps text-[0.72rem] mt-6" style={{ color: "#c1272d", letterSpacing: "0.22em", fontWeight: 600 }}>
            MILLENIUM · 2027
          </p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3">
            Fêtes internationales<br />de saint Léonard
          </h1>
          <p className="font-body italic text-base sm:text-lg mt-5 max-w-3xl mx-auto" style={{ color: "var(--muted)" }}>
            Sept étapes à travers le monde, comme sept flammes portant à la baie du Mont-Saint-Michel le chant du millénaire.
          </p>
        </section>

        {/* Timeline */}
        <section className="max-w-6xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FETES_LOCATIONS_SORTED.map((loc) => (
              <Link
                key={loc.slug}
                to={`/fetes-internationales/${loc.slug}`}
                data-testid={`fete-card-${loc.slug}`}
                className="group block relative overflow-hidden transition-transform"
                style={{
                  borderTop: `4px solid ${loc.accent_color}`,
                  background: `linear-gradient(135deg, ${loc.hero_color} 0%, ${loc.hero_color}dd 100%)`,
                  minHeight: 260,
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
              >
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(20,16,12,0.10) 0%, rgba(20,16,12,0.45) 100%)" }} />
                <div className="relative p-6 h-full flex flex-col justify-between text-white">
                  <div>
                    <div className="text-4xl mb-2" aria-hidden>{loc.flag}</div>
                    <div className="font-caps text-[0.65rem]" style={{ letterSpacing: "0.18em", opacity: 0.85 }}>
                      {loc.country.toUpperCase()}
                    </div>
                    <h2 className="font-display text-3xl mt-1">{loc.city}</h2>
                  </div>
                  <div className="mt-6">
                    <div className="font-body text-base" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.4)" }}>{loc.dates}</div>
                    <div className="font-caps text-[0.65rem] mt-2" style={{ letterSpacing: "0.2em", color: loc.accent_color, background: "#fff", display: "inline-block", padding: "3px 8px", fontWeight: 600 }}>
                      {loc.theme.toUpperCase()}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Closing */}
        <section className="py-16 px-6 text-center border-t" style={{ borderColor: "var(--gold)", background: "var(--parchment-2, #f4ecd8)" }}>
          <Ornament />
          <p className="font-body italic text-lg mt-4 max-w-2xl mx-auto" style={{ color: "var(--ink-2)" }}>
            Chaque étape sera relayée vers Vains, en baie du Mont-Saint-Michel, où se célébreront les Fêtes du millénaire les 2, 3 et 4 juillet 2027.
          </p>
          <div className="mt-8">
            <Link to="/presence" data-testid="fetes-back-presence" className="btn btn-primary">
              Fêtes du Millenium à Vains →
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}
